import React, { Fragment, useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import PropType from 'prop-types'
import { useQuery } from '@apollo/client'
import { Title } from '@lib'
import { Loader } from '@shared'
import Dashboard from '@wrappers/Dashboard'
import { axiosGet } from '@utils'

import resourcesGql from '@graphql/queries/resources'

const Content = ({ user }) => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [videoSignedUrl, setVideoSignedUrl] = useState(null)
  const [pdfSignedUrl, setPdfSignedUrl] = useState(null)
  const [activeTab, setActiveTab] = useState('video')

  const resourceQuery = useQuery(resourcesGql, { variables: { id } })
  const resCourse = resourceQuery.data?.resources?.[0]

  useEffect(() => {
    if (!resCourse) return
    if (resCourse.videoUrl) {
      axiosGet(`s3/resource-media/${resCourse.videoUrl}?inline=true`).then(res => setVideoSignedUrl(res.data.url))
    }
    if (resCourse.pdfUrl) {
      axiosGet(`s3/resource-media/${resCourse.pdfUrl}?inline=true`).then(res => setPdfSignedUrl(res.data.url))
      if (!resCourse.videoUrl) setActiveTab('pdf')
    }
  }, [resCourse?.id])

  if (resourceQuery.loading) return <Loader/>
  if (resourceQuery.error) return null

  const hasBoth = resCourse.videoUrl && resCourse.pdfUrl

  return (
    <Fragment>
      <Title text={resCourse.name} user={user}/>
      <button className='course-back-btn' onClick={() => navigate('/help-center/training-courses')}>
        <i className='fas fa-arrow-left'/> Back to Training Courses
      </button>
      <div className='embed-course-page'>
        {hasBoth && (
          <div className='course-tab-nav'>
            <button className={`course-tab-btn${activeTab === 'video' ? ' active' : ''}`} onClick={() => setActiveTab('video')}>Video</button>
            <button className={`course-tab-btn${activeTab === 'pdf' ? ' active' : ''}`} onClick={() => setActiveTab('pdf')}>PDF</button>
          </div>
        )}
        {resCourse.videoUrl && (!hasBoth || activeTab === 'video') && (
          <video className='embed-course' controls src={videoSignedUrl || ''} />
        )}
        {resCourse.pdfUrl && (!hasBoth || activeTab === 'pdf') && (
          <iframe className='embed-course' src={pdfSignedUrl || ''} />
        )}
      </div>
    </Fragment>
  )
}

Content.propTypes = {
  user: PropType.object
}

const EmbedCourse = () => {
  return (
    <Dashboard>
      <Content/>
    </Dashboard>
  )
}

export default EmbedCourse
